// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityPreferredSpecialty {
    static getAttributeTypeMap() {
        return MedicalEligibilityPreferredSpecialty.attributeTypeMap;
    }
}
MedicalEligibilityPreferredSpecialty.discriminator = undefined;
MedicalEligibilityPreferredSpecialty.additionalProperties = false;
MedicalEligibilityPreferredSpecialty.attributeTypeMap = [
    {
        "name": "pharmacy",
        "baseName": "pharmacy",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityPreferredSpecialty.js.map